import {
    Chord,
    Tone,
} from "../model/core";

function assertNoDistinctKeys(keys: String[]) {
    const distinctKeys = new Set(keys);
    if (distinctKeys.size > 1) {
        throw new Error("Distinct keys found in ChordAliasPartition registration: " + JSON.stringify(keys));
    }
}

const buildPartitionKey = (c : Chord) => {
    const k = c.tones.map(t => t instanceof Tone ? t.index : t).sort((a, b) => a - b);
    return k.join(",");
}

export class ChordAliasPartition {
    private static partitions: Map<string, Chord[]> = new Map();
    static register(particionChords: Chord[]) {
        if (particionChords.length === 0) return;

        const keys = particionChords.map(c => buildPartitionKey(c));
        assertNoDistinctKeys(keys);
        const partitionKey = keys[0];

        if (this.partitions.has(partitionKey)) return;
        this.partitions.set(partitionKey, particionChords);
    }

    static get(c: Chord): Chord[] | undefined {
        const k = buildPartitionKey(c);

        if (!this.partitions.has(k)) {
            console.warn("No partition found for chord: ", c, " with key: ", k);
            return undefined;
        }

        return this.partitions.get(k);
    }
}